import localeEn from './en';
import localeHr from './hr';
import localeSr from './sr';
import localeBh from './bh';
import useStore from '../state/zustand';

const translations = {
    hr: localeHr,
    en: localeEn,
    sr: localeSr,
    bh: localeBh,
};

export const localeFull = {
    hr: 'Croatian',
    en: 'English',
    sr: 'Serbian',
    bh: 'Bosnian',
};

// Memoizacija dict() poziva
let cachedDict = null;
let cachedLang = null;

const dict = () => {
    const language = useStore.getState().locale || 'en';

    if (cachedLang !== language) {
        cachedLang = language;
        // Štitiš se od mutacije, ali kopiraš SAMO kad se promijeni jezik
        cachedDict = { ...translations[language] || translations.en };
    }

    return cachedDict;
};

const translate = (text) => {
    const currentDict = dict();
    return currentDict[text] || text;
};

const dictionaryTranslate = (text, customDict) => {
    const activeDict = customDict || dict();
    return activeDict[text] || text;
};

const getLanguagesInArray = () => {
    return Object.keys(translations);
};

const activeLanguage = () => {
    return useStore.getState().locale || 'en';
};

export default translate;

export {
    getLanguagesInArray,
    translations,
    translate,
    activeLanguage,
    dictionaryTranslate,
};
